








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryDailySalesStatList,ExportDailySalesStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class DailySalesStatList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1


  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '销售额', param: 'salesAmount' },
    { title: '微信销售额', param: 'salesAmountWechat' },
    { title: '微信小程序销售额', param: 'salesAmountWechatApplet' },
    { title: '支付宝销售额', param: 'salesAmountAlipay' },
    { title: '银行卡销售额', param: 'salesAmountBankpay' },
    { title: '绿豆销售额', param: 'salesAmountMengbean' },
    { title: '退款金额', param: 'refundAmount' },
    { title: '销售获得PV值', param: 'pvGainedFromSales' },
    { title: '平台PV值', param: 'platformPv' },
    { title: '全部订单数', param: 'totalOrderCount' },
    { title: '待收货', param: 'toBeReceived' },
    { title: '已收货', param: 'received' },
    { title: '申请退款', param: 'refundApplied' },
    { title: '已退款', param: 'refundCompleted' },
    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      fixed: 'right',
      width:220,
      operation: [
        { title: '销售额明细', click: this.jumpTo1 },
        { title: '退款明细', click: this.jumpTo2 },
        { title: '结算明细', click: this.jumpTo3 },
      ],
    },
  ]

  private jumpTo1(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/orderList",
      query:{
        createTime: data.statDate,
        activeMenu: 'pay'
      }
    })
  }
  private jumpTo2(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/orderList",
      query:{
        successRefundTime: data.statDate,
        activeMenu: 'refund',
        orderStatus: '23'
      }
    })
  }
  private jumpTo3(data: any){
    // 跳转到数据源
    this.$router.push({
      path: "/settlementOrderList",
      query:{
        settlementTime: data.statDate,
        activeMenu: 'finish'
      }
    })
  }

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportDailySalesStat(param,"每日销售数据统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryDailySalesStatList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
